module.exports = __webpack_public_path__ + "img/avatar3.1b08f38a.png";